import React from 'react';
import PropTypes from 'prop-types';

import styled from 'styled-components';
import { NitroPanel, NitroText } from 'nitro-components';

import { connect } from 'react-redux';
// import { getBusinessReports, getReportsCCAndCountry } from '../../../selector';

const Content = styled.div`
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  > * {
    margin: 4px;
  }
`;
const Fields = ({ selectedFields }) => {
  return (
    <Content>
      {selectedFields.map(field =>
        <NitroPanel boxShadowLight key={field.name} padding="8px 20px">
          <NitroText variant="primary" bold size="2">
            {field.name}
          </NitroText>
        </NitroPanel>
      )}
    </Content>
  );
};

Fields.propTypes = {};

// TODO: move to selector
const mapStateToProps = state => {
  const { selectedFields } = state.reports;
  return { selectedFields };
};

export default connect(mapStateToProps)(Fields);



// WEBPACK FOOTER //
// ./src/features/scheduling-reports/new-report/Summary/Sections/Fields.js